<div class="card panel-flat-color secondary-panel">
    <div class="panel-flat-header">
        <h3>Billing Scenarios</h3>
        <div class="checkbox show-disabled">
            <label> <input type="checkbox" [(ngModel)]="showDisabled" />Show disabled Billing Scenarios </label>
        </div>
        <div class="float-end header-button-container">
            <div class="ws-display-inline-block">
                <div class="date-selector ws-flex-container-horizontal ws-flex-align-items-center">
                    <span>Tax Year:</span>
                    <ws-select
                        [options]="taxYears"
                        [isPrimitive]="true"
                        size="sm"
                        [ngModel]="selectedYear"
                        (ngModelChange)="yearChanged($event)"
                    >
                    </ws-select>
                </div>
            </div>
            <div class="ws-display-inline-block" helpTooltip helpContentId="collector.add-billing-scenario">
                @if (!viewOnly) {
                    <button class="ace-btn btn-text has-icon fa fa-plus-circle" (click)="openScenario()"></button>
                }
            </div>
        </div>
    </div>
    <div class="panel-flat-body">
        @if (showYearWarning) {
            <div class="payment-warning">
                <i class="fa fa-warning"></i>
                <span
                    >Displayed payment due dates use current due date values and may not be accurate to the values used
                    historically</span
                >
            </div>
        }
        <div class="scenarios">
            @for (scenario of collector.collectorBillScenarios; track scenario) {
                @if (showDisabled || scenario.enabled) {
                    <div class="scenario clickable" (click)="openScenario(scenario)">
                        <div
                            class="scenario-title ws-flex-container-horizontal ws-flex-justify-content-space-between ws-flex-align-items-center"
                        >
                            <h4 class="ws-font-weight-bold ws-no-margin">
                                @if (scenario.name !== null) {
                                    <span>{{ scenario.name }}</span>
                                }
                                @if (scenario.name === null) {
                                    <span>Scenario</span>
                                }
                            </h4>
                            @if (scenario.isDefault) {
                                <div class="default-scenario">
                                    <h4 class="ws-no-margin">Default</h4>
                                </div>
                            }
                        </div>
                        <div class="bills ws-flex-container-vertical ws-stretch">
                            @for (bill of scenario.collectorBills; track bill; let first = $first) {
                                <div class="bill ws-flex-container-horizontal" style="overflow-x: auto">
                                    <div>
                                        <div class="">{{ bill.name }}</div>
                                        <div class="" style="margin-top: 10px">Payment Option(s):</div>
                                    </div>
                                    <div class="options ws-flex-container-vertical">
                                        @for (
                                            option of bill.collectorPaymentOptions | sortBy: 'asc' : 'isDefault';
                                            track option;
                                            let first = $first
                                        ) {
                                            <div>
                                                @if (!first) {
                                                    <div
                                                        class="or-break ws-flex-container-horizontal ws-stretch-width ws-flex-align-items-center"
                                                    >
                                                        <div class="break-line"></div>
                                                        <span>or</span>
                                                        <div class="break-line"></div>
                                                    </div>
                                                }
                                                <div class="option ws-flex-container-horizontal">
                                                    <div class="col-md-3 ws-flex-container-horizontal">
                                                        @if (
                                                            option.isDefault && bill.collectorPaymentOptions.length > 1
                                                        ) {
                                                            <div class="default-opt">Default</div>
                                                        }
                                                        <span class="option-name"
                                                            >{{
                                                                option.name !== null ? option.name : 'Payment option'
                                                            }}
                                                            :</span
                                                        >
                                                    </div>
                                                    <div class="option-details col-md-9">
                                                        <table class="payments ws-stretch-width">
                                                            @for (
                                                                payment of option.collectorPayments
                                                                    | sortBy: 'asc' : paymentOrder;
                                                                track payment;
                                                                let paymentIndex = $index
                                                            ) {
                                                                <tr
                                                                    class="payment"
                                                                    [ngClass]="{ even: paymentIndex % 2 }"
                                                                >
                                                                    <td>
                                                                        <span>{{
                                                                            payment.name !== null
                                                                                ? payment.name
                                                                                : 'Payment'
                                                                        }}</span>
                                                                    </td>
                                                                    <td class="text-align-right">
                                                                        <span>due</span>
                                                                    </td>
                                                                    <td class="payment-date text-align-right">
                                                                        <span
                                                                            >{{ payment.dueMonthDay }}/{{
                                                                                toWords(payment.dueYearID)
                                                                            }}</span
                                                                        >
                                                                    </td>
                                                                    <td class="tax-period">
                                                                        <span>Tax Period:</span>
                                                                    </td>
                                                                    <td class="payment-date text-align-right">
                                                                        <span
                                                                            >{{ payment.accrualBeginDate }}/{{
                                                                                toWords(payment.accrualBeginYearID)
                                                                            }}</span
                                                                        >
                                                                    </td>
                                                                    <td class="text-aligh-center">
                                                                        <span>to</span>
                                                                    </td>
                                                                    <td>
                                                                        <span
                                                                            >{{ payment.accrualEndDate }}/{{
                                                                                toWords(payment.accrualEndYearID)
                                                                            }}</span
                                                                        >
                                                                    </td>
                                                                </tr>
                                                                @if (payment.discountPercent > 0) {
                                                                    <tr
                                                                        class="payment"
                                                                        [ngClass]="{ even: paymentIndex % 2 }"
                                                                    >
                                                                        <td colspan="3"></td>
                                                                        <td class="tax-period">
                                                                            <span>Discount:</span>
                                                                        </td>
                                                                        <td colspan="3" class="text-aligh-center"
                                                                            >{{ payment.discountPercent * 100 }}
                                                                            %
                                                                        </td>
                                                                    </tr>
                                                                }
                                                            }
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
            }
        </div>
    </div>
</div>
